import { createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/select.svg'


const _withScopeId = n => (_pushScopeId("data-v-a7446748"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "border border-white border-opacity-50 rounded-md flex flex-row px-2 py-1 mb-4" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("GO TO TRANSACTION DETAILS")
const _hoisted_3 = { class: "border border-white border-opacity-50 rounded-md flex flex-row px-2 py-1 mb-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */))
const _hoisted_5 = { class: "border border-white border-opacity-50 rounded-md flex flex-row px-2 py-1 mb-4" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" GO TO TRANSACTION DETAILS ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_nomad_button = _resolveComponent("nomad-button")!
  const _component_n_tab_pane = _resolveComponent("n-tab-pane")!
  const _component_n_popselect = _resolveComponent("n-popselect")!
  const _component_n_tabs = _resolveComponent("n-tabs")!
  const _component_n_card = _resolveComponent("n-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" search transaction "),
    _createVNode(_component_n_card, {
      class: "search-card",
      title: "Search Transaction",
      bordered: false,
      size: "huge",
      role: "dialog",
      "aria-modal": "true"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_n_tabs, {
          value: _ctx.name,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.name) = $event)),
          type: "card",
          "tab-style": "min-width: 80px;",
          "justify-content": "space-evenly"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_n_tab_pane, {
              name: _ctx.panels[0]
            }, {
              default: _withCtx(() => [
                _createCommentVNode(" Tx Hash "),
                _createElementVNode("div", _hoisted_1, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.txHash) = $event)),
                    placeholder: "Transaction Hash",
                    class: "w-full border-0 outline-none bg-transparent"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, _ctx.txHash]
                  ])
                ]),
                _createVNode(_component_nomad_button, {
                  primary: "",
                  onClick: _ctx.goConnext,
                  class: "w-full flex justify-center"
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["name"]),
            _createVNode(_component_n_tab_pane, {
              name: _ctx.panels[1]
            }, {
              default: _withCtx(() => [
                _createCommentVNode(" Origin network select "),
                _createVNode(_component_n_popselect, {
                  value: _ctx.originNetwork,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.originNetwork) = $event)),
                  options: _ctx.options,
                  placement: "bottom-start",
                  trigger: "click",
                  width: "trigger",
                  class: "capitalize"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.originNetwork) = $event)),
                        placeholder: "Origin Network",
                        readonly: "",
                        class: "w-full border-0 outline-none bg-transparent capitalize"
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, _ctx.originNetwork]
                      ]),
                      _hoisted_4
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["value", "options"]),
                _createCommentVNode(" Tx Hash "),
                _createElementVNode("div", _hoisted_5, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.txHash) = $event)),
                    placeholder: "Transaction Hash",
                    class: "w-full border-0 outline-none bg-transparent"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, _ctx.txHash]
                  ])
                ]),
                _createVNode(_component_nomad_button, {
                  primary: "",
                  onClick: _ctx.goNomad,
                  class: "w-full flex justify-center"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["name"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["value"])
      ]),
      _: 1 /* STABLE */
    })
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}